import { render, staticRenderFns } from "./AdyenPaymentProvider.vue?vue&type=template&id=20543f28&scoped=true&"
import script from "./AdyenPaymentProvider.vue?vue&type=script&lang=js&"
export * from "./AdyenPaymentProvider.vue?vue&type=script&lang=js&"
import style0 from "./AdyenPaymentProvider.vue?vue&type=style&index=0&id=20543f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20543f28",
  null
  
)

export default component.exports